// extracted by mini-css-extract-plugin
export default {"productGrid":"f0-z","centerLink":"g0-z","productSection":"h0-z","item":"i0-z","ctaButton":"j0-z"};